import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages';
import { Provider } from 'react-redux';
import store from './redux/store';
import * as serviceWorker from './serviceWorker';
import './i18n';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from './redux/store';

const render = (Component) => {
  return ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary>
          <Component />
        </ErrorBoundary>
      </PersistGate>
    </Provider>,
    document.getElementById('root'),
  );
};

serviceWorker.unregister();

render(App);

if (module.hot) {
  module.hot.accept('./pages', () => {
    const NextApp = require('./pages').default;
    render(NextApp);
  });
}
